import { render, staticRenderFns } from "./posReceipt.vue?vue&type=template&id=78c4909a&scoped=true&"
import script from "./posReceipt.vue?vue&type=script&lang=js&"
export * from "./posReceipt.vue?vue&type=script&lang=js&"
import style0 from "./posReceipt.vue?vue&type=style&index=0&id=78c4909a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4909a",
  null
  
)

export default component.exports